export default __webpack_public_path__ + "static/04.04-bcecb6622de67a36122c5cc637fb389f.png";